import { createFeatureSelector, createSelector } from "@ngrx/store";
import { SearchState } from "./search.reducer";

export const getSearchState = createFeatureSelector<SearchState>("search");

export const selectSearchResults = createSelector(
  getSearchState,
  (state) => state.searchResults
);

export const selectSearchResultsTotal = createSelector(
  getSearchState,
  (state) => state.totalMatching
);

export const selectSearchCollectionName = createSelector(
  getSearchState,
  (state) => state.collectionName
);

export const selectSearchTerm = createSelector(
  getSearchState,
  (state) => state.searchTerm
);

export const selectSearchLoading = createSelector(
  getSearchState,
  (state) => state.loading
);

export const selectSearchFilters = createSelector(
  getSearchState,
  (state) => state.searchFilters
);

export const selectSelectedSearchFilters = createSelector(
  getSearchState,
  (state) => state.selectedFilters
);
